import { SET_ACTIVE_FOOTER_MENU } from './action';

function footerMenuReducer(state=0, action){
    switch (action.type) {
        
        case SET_ACTIVE_FOOTER_MENU:
          return action.payload;
    }
    return state;
}

export default footerMenuReducer;
